export type SidebarCollapsePreference = boolean | null;

export function readSidebarCollapsePreference(value: string | null): SidebarCollapsePreference {
  if (value === '1') return true;
  if (value === '0') return false;
  return null;
}

export function sidebarCollapsedForViewport(
  preference: SidebarCollapsePreference,
  isNarrowViewport: boolean,
): boolean {
  return preference ?? isNarrowViewport;
}
